import { InjectionToken } from '@angular/core';

import { PromotionMap } from '@frontend/sports/crm/promotion/data-access';
import { Observable } from 'rxjs';

export interface PromotionMapIntegration {
    readonly promotionsMap$: Observable<PromotionMap>;
}

export const PROMOTION_MAP_INTEGRATION_TOKEN = new InjectionToken<PromotionMapIntegration>('PROMOTION_MAP_INTEGRATION_TOKEN');
